import { render, staticRenderFns } from "./MemberCardDetail.vue?vue&type=template&id=c4875460"
import script from "./MemberCardDetail.vue?vue&type=script&lang=js"
export * from "./MemberCardDetail.vue?vue&type=script&lang=js"
import style0 from "./MemberCardDetail.vue?vue&type=style&index=0&id=c4875460&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports